"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanGoBack = void 0;
function getCanGoBack(currentStepIndex, steps) {
    const previousStep = steps[currentStepIndex - 1];
    const previousStepIsClick = (previousStep === null || previousStep === void 0 ? void 0 : previousStep.type) === 'Click';
    return currentStepIndex > 0 && !previousStepIsClick;
}
exports.getCanGoBack = getCanGoBack;
//# sourceMappingURL=getCanGoBack.js.map